import { Icon } from '../regureStyles';

const Feedback = ({ uploadMsg }) => {
  if (!uploadMsg) <></>;

  return (
    <div
      style={{
        background: uploadMsg.ok ? '#ecfdf5' : '#fef2f2',
        border: `1px solid ${uploadMsg.ok ? '#6ee7b7' : '#fca5a5'}`,
        borderRadius: 8,
        padding: '10px 16px',
        marginBottom: 16,
        fontSize: 13,
        color: uploadMsg.ok ? '#065f46' : '#991b1b',
        display: 'flex',
        alignItems: 'center',
        gap: 8,
      }}
    >
      <Icon name={uploadMsg.ok ? 'check-circle' : 'alert-circle'} size={15} color={uploadMsg.ok ? '#10b981' : '#ef4444'} />
      {uploadMsg.text}
    </div>
  );
};

export default Feedback;
